import Vue from 'vue'
import {namespace} from 'vuex-class'
import {APARTMENT_MODULE_NAMESPACE, APARTMENT_SET_APARTMENT_BY_FIELD} from '../../../../store/apartment'
import {IApartment, IApartmentListingViewModel} from '../../../../models/apartment'
import {AddressDto, IAddress} from '../../../../models/address/address.model'

const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)

export class ApartmentViewModal extends Vue {
  /* eslint-disable no-undef */
  @ApartmentStore.Getter apartment: IApartment
  @ApartmentStore.Getter apartments: IApartmentListingViewModel[]

  @ApartmentStore.Mutation(APARTMENT_SET_APARTMENT_BY_FIELD)
  storeAssignValueForApartment: (payload: { [key: string]: any }) => void;

  dtTemporaryMaintenanceReferent: any[] | null;
  dtTemporaryVehicleReferent: any[] | null;

  constructor () {
    super()
    this.dtTemporaryMaintenanceReferent = []
    this.dtTemporaryVehicleReferent = []
  }

  get block () {
    return this.apartment.block
  }

  set block (value: number) {
    this.storeAssignValueForApartment({block: value})
  }

  get numApartment () {
    return this.apartment.num_apartment
  }

  set numApartment (value: number) {
    this.storeAssignValueForApartment({num_apartment: value})
  }

  get tenant () {
    return this.apartment.tenant
  }

  set tenant (value: number[]) {
    this.storeAssignValueForApartment({tenant: value})
  }

  get owner () {
    return this.apartment.owner
  }

  set owner (value: number[]) {
    this.storeAssignValueForApartment({owner: value})
  }

  get floor () {
    return this.apartment.floor
  }

  set floor (value: number) {
    this.storeAssignValueForApartment({floor: value})
  }

  get surface () {
    return this.apartment.surface
  }

  set surface (value: number) {
    this.storeAssignValueForApartment({surface: value})
  }

  get type () {
    return this.apartment.type
  }

  set type (value: string) {
    this.storeAssignValueForApartment({type: value})
  }

  get apartmentAsBlock () {
    return this.apartment.apartment_as_block || {}
  }

  set apartmentAsBlock (value: any) {
    this.storeAssignValueForApartment({
      apartment_as_block: {
        ...this.apartmentAsBlock,
        ...value
      }
    })
  }

  get maintenanceReferents (): any[] {
    console.log('Référent', this.apartmentAsBlock.maintenance_referents)
    return this.apartmentAsBlock.maintenance_referents
  }

  set maintenanceReferents (value: any[]) {
    this.apartmentAsBlock = { maintenance_referents: value }
  }

  get vehicleReferents (): any[] {
    return this.apartmentAsBlock.vehicle_referents
  }

  set vehicleReferents (value: any[]) {
    this.apartmentAsBlock = { vehicle_referents: value }
  }

  get buildingName (): string {
    return this.apartmentAsBlock.building || null
  }

  set buildingName (value: string) {
    this.apartmentAsBlock = { building: value }
  }

  get buildingActivity (): string {
    return this.apartmentAsBlock.building_activity
  }

  set buildingActivity (value: string) {
    this.apartmentAsBlock = { building_activity: value }
  }

  get buildingFunction (): string {
    return this.apartmentAsBlock.building_function
  }

  set buildingFunction (value: string) {
    this.apartmentAsBlock = { building_function: value }
  }

  get acquisition (): string {
    return this.apartmentAsBlock.acquisition
  }

  set acquisition (value: string) {
    this.apartmentAsBlock = { acquisition: value }
  }

  get constructionDate (): string {
    return this.apartmentAsBlock.construction_date
  }

  set constructionDate (value: string) {
    this.apartmentAsBlock = { construction_date: value }
  }

  get excludeMaintenanceCost (): boolean {
    return this.apartmentAsBlock.exclude_maintenance_cost
  }

  set excludeMaintenanceCost (value: boolean) {
    this.apartmentAsBlock = { exclude_maintenance_cost: value }
  }

  get category (): string {
    return this.apartmentAsBlock.category
  }

  set category (value: string) {
    this.apartmentAsBlock = { category: value }
  }

  get nbParking (): string {
    return this.apartmentAsBlock.nb_parking
  }

  set nbParking (value: string) {
    this.apartmentAsBlock = { nb_parking: value }
  }

  get nbBasement (): string {
    return this.apartmentAsBlock.nb_basement
  }

  set nbBasement (value: string) {
    this.apartmentAsBlock = { nb_basement: value }
  }

  get nbFloor (): string {
    return this.apartmentAsBlock.nb_floor
  }

  set nbFloor (value: string) {
    this.apartmentAsBlock = { nb_floor: value }
  }

  get email (): string {
    return this.apartmentAsBlock.email
  }

  set email (value: string) {
    this.apartmentAsBlock = { email: value }
  }

  get landline (): string {
    return this.apartmentAsBlock.landline
  }

  set landline (value: string) {
    this.apartmentAsBlock = { landline: value }
  }

  get hub (): string {
    return this.apartmentAsBlock.hub
  }

  set hub (value: string) {
    this.apartmentAsBlock = { hub: value }
  }

  get address (): IAddress {
    return this.apartmentAsBlock.address || new AddressDto()
  }

  set address (value: IAddress) {
    this.apartmentAsBlock = { address: value }
  }
}



// WEBPACK FOOTER //
// ./src/containers/block/components/block-apartment-vertical-modal/appartment.viewmodal.ts